<template>
    <v-dialog v-model="createSubAllotmentDialog" max-width="500">
        <template v-slot="{isActive}">
            <v-card title="Dialog">
                <v-card-text>
                    <v-form v-model="createSuballotmentValid">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="newSuballotmentName"
                                    :rules="[requiredRule('suballotment_name')]"
                                    :label="`${$t('suballotment_name')}*`"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        :disabled="!createSuballotmentValid"
                        :loading="props.loading"
                        @click="emit('submit', newSuballotmentName)"
                    >
                        {{ $t('save') }}
                    </v-btn>
                    <v-btn @click="isActive.value = false"> {{ $t('cancel') }} </v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

<script setup lang="ts">
    import {requiredRule} from '~/composables/rules'

    const createSubAllotmentDialog = defineModel<boolean>({
        default: false,
    })
    const props = defineProps<{
        loading: boolean
    }>()

    const createSuballotmentValid = ref(false)
    const newSuballotmentName = ref('')

    const emit = defineEmits<{
        (e: 'submit', value): void
    }>()
</script>
